import { create } from "zustand";
import { handleSetWAIntegrationDetails } from "../utils/WAStore.utils";

export const useWAIntegrationStore = create((set) => ({
  details: null,
  setDetails: handleSetWAIntegrationDetails(set),
}));
